import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-secondary)";

function IconCheck({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M3.612 5.283 8.47.152a.472.472 0 0 1 .694 0l.693.733a.54.54 0 0 1 0 .733L3.96 7.848a.472.472 0 0 1-.693 0L.144 4.55a.54.54 0 0 1 0-.733l.693-.733a.472.472 0 0 1 .694 0l2.081 2.199z"/>
        </svg>
    );
}

export default IconCheck;

